import { Button, Label, TextArea } from "abs-ui-components";
import { MDBCol, MDBRow } from "mdbreact";
import { Controller, useFormContext } from "react-hook-form";
import { c3Fields } from "../../FeuConstants";
import "./FeuC31ListOfVoyages.scss";
import { useParams } from "react-router";
import { forwardRef, useEffect, useMemo, useRef } from "react";
import { callApi } from "../../../../../services/MonitoringPlanService";
import { API_ROUTES } from "../../FeuApiRoutes/FeuApiRoutes";
import { emitToasterMsg } from "../../../../../services/toasterUtility";
import AutoSave from "../../../../../common/AutoSave/AutoSave";
import { AUTOSAVE_SUCCESS_MESSAGE } from "../../../Mrv/Constants";


const FeuC31ListOfVoyages = forwardRef(({ c31VoyagesList, refetchMonitoringData,vesselMstId }, ref) => {

    const { control, getValues, reset, formState } = useFormContext();
    const lastManualSave = useRef(null);
    const manualSaveTriggered = useRef(false);
    const savedValuesRef = useRef({});
    const { dirtyFields } = formState;
    const isC31Dirty = !!(dirtyFields?.c31 && Object.keys(dirtyFields.c31).length > 0);

    useEffect(() => {
        if (c31VoyagesList) {
            reset(prev => ({ ...prev, c31: c31VoyagesList }));
        }
    }, [c31VoyagesList, reset]);

    AutoSave(ref, [], async () => {
        const currentValues = getValues("c31");
        const isChanged = Object.keys(currentValues || {}).some(
            key => currentValues[key] !== savedValuesRef.current?.[key]
        );
        if (!isC31Dirty || !isChanged) return;
        await handleSave(true);
    });

    const handleSave = async (isAuto = false) => {
        const formValues = getValues("c31");
        const payload = {
            ...c3FieldsColumns.reduce((acc, { name }) => {
                acc[name] = formValues?.[name] || "";
                return acc;
            }, {}),
        };
        try {
            const C31ListOfVoyages = await callApi({
                method: "POST",
                url: API_ROUTES.C31(vesselMstId),
                data: payload,
            });
            if (C31ListOfVoyages?.isSuccess) {
                emitToasterMsg("success", "Table C31", isAuto ? AUTOSAVE_SUCCESS_MESSAGE : "Created successfully");
                reset(prev => ({ ...prev, c1: formValues }));
                savedValuesRef.current = { ...formValues };
                if (!isAuto) {
                    lastManualSave.current = Date.now();
                }
                // emitToasterMsg("success", "Table C31", "Created successfully");
                if (typeof refetchMonitoringData === "function") {
                    await refetchMonitoringData();
                }
            }
            else {
                emitToasterMsg("error", "Table C.3.1", C31ListOfVoyages?.errorMessage);
            }
        } catch (error) {
            emitToasterMsg("error", "Table C.3.1", error.errorMessage);
        }
    };

    const c3FieldsColumns = useMemo(() => {
        const base = c3Fields.filter(f => f.name !== "methodDescription");
        const responsibleField = {
            label: "Name of person or position responsible for this procedure",
            name: "responsiblePersonOrPosition",
            maxLength: 1000,
        };

        const i = base.findIndex(f => f.name === "descriptionOfProcedure");

        if (i !== -1) {
            base.splice(i + 1, 0, responsibleField);
        } else {
            base.push(responsibleField);
        }

        return base;
    }, []);

    return (

        <div className="form-section mt-5">
            <MDBRow className="mb-2">
                <MDBCol md="4">
                    <h6 className="titles-font">Title of procedure</h6>
                </MDBCol>
                <MDBCol md="4">
                    <h6 className="titles-font">Recording and safeguarding completeness of voyages</h6>
                </MDBCol>
            </MDBRow>

            {c3FieldsColumns.map(({ label, name, maxLength }) => {
                const displayLabel =
                    label === "Description of procedures"
                        ? "Description of procedures (including recording voyages, monitoring voyages etc.) (a brief description of the procedure can be provided if already existing outside the monitoring plan)"
                        : label;
                return (
                    <MDBRow className="align-items-center mb-3" key={name}>
                        <MDBCol md="4">
                            <Label name={displayLabel} bold />
                        </MDBCol>
                        <MDBCol md="4">
                            <Controller
                                name={`c31.${name}`}
                                control={control}
                                render={({ field }) => (
                                    <TextArea
                                        id={`c31_${name}`}
                                        className="textarea-resize"
                                        value={field.value || ""}
                                        onChange={field.onChange}
                                        placeholder=""
                                        maxLength={maxLength}
                                        row={1}
                                    />
                                )}
                            />
                        </MDBCol>
                    </MDBRow>
                );
            })}

            <div
                className="form-row"
                style={{ marginTop: "20px", display: "flex", justifyContent: "center" }}
            >
                <Button id="save_c31_btn"
                    disabled={!isC31Dirty}
                    onClick={async () => {
                        manualSaveTriggered.current = true;
                        await handleSave(false);
                    }}>
                    Save
                </Button>
            </div>
        </div>

    );
});

export default FeuC31ListOfVoyages;
